import { UseFormSetValue } from 'react-hook-form';

import { AspirationsToday } from '@/rtk-query.gql';
import { convertTime, formatTime } from '@/utils';

import { AspirationFormValues } from './schema';

export function getTemps() {
  const temps = [{ value: '99', label: '--Temp (Celsius)--' }];

  for (let i = 0; i <= 40; i++) {
    temps.push({ value: `${i}C`, label: `${i}C` });
  }

  return temps;
}

export function getPumpPressures() {
  const pressures = [{ value: '99', label: '--Pump Pressure--' }];

  for (let i = 50; i <= 111; i++) {
    pressures.push({ value: `${i}mmHg`, label: `${i}mmHg` });
  }

  return pressures;
}

export const updateAspirationTimeZones = (
  aspirations: AspirationsToday[],
  newTimeZone: string,
  originalTimeZone: string, //timezone
) => {
  return aspirations.map((aspiration) => {
    const updatedAspiration = {
      ...aspiration,
      aspirationTime: convertTime(
        aspiration?.aspirationTime as string,
        newTimeZone,
        originalTimeZone,
      ) as string,
    };

    if (aspiration.matTime) {
      updatedAspiration['matTime'] = convertTime(
        aspiration.matTime,
        newTimeZone,
        originalTimeZone,
      ) as string;
    }
    if (aspiration.ivmTime) {
      updatedAspiration['ivmTime'] = convertTime(
        aspiration.ivmTime,
        newTimeZone,
        originalTimeZone,
      ) as string;
    }

    return updatedAspiration;
  });
};

export const setMinute = (setValue: UseFormSetValue<AspirationFormValues>) => {
  const now = new Date();
  const secondsUntilNextMinute = 60 - now.getSeconds();
  const initialDelay = secondsUntilNextMinute * 1000;

  setValue('opuTime', formatTime(new Date().toISOString()));

  const initialTimer = setTimeout(() => {
    setValue('opuTime', formatTime(new Date().toISOString()));

    const timer = setInterval(() => {
      setValue('opuTime', formatTime(new Date().toISOString()));
    }, 60000);

    return () => clearInterval(timer);
  }, initialDelay);

  return () => clearTimeout(initialTimer);
};

export const calculateLastBredDate = (
  aspirationDate: string,
  daysPregnant: number,
): Date => {
  const [month, day, year] = aspirationDate.split('-').map(Number);
  const aspirationDateObj = new Date(year, month - 1, day);
  const lastBredDate = new Date(aspirationDateObj);
  lastBredDate.setDate(lastBredDate.getDate() - daysPregnant);
  return lastBredDate;
};
